import { combineReducers, Reducer, Action } from 'redux';
import { reducer as formReducer, FormStateMap } from 'redux-form';

import { sessionReducer, SessionReducerState } from './factory/login/sessionReducer';
import { sideNavReducer, SideNavReducerState } from './factory/sidenav/sideNavReducer';
import { snackbarReducer, SnackbarReducerState } from './factory/main/snackbarReducer';
import { blockUIReducer, BlockUIReducerState } from './factory/main/blockUIReducer';
import { navigationReducer, NavigationReducerState } from './factory/main/navigationReducer';
import { versionCheckerReducer, VersionCheckerReducerState } from './factory/version/versionCheckerReducer';
import { passwordResetReducer, PasswordResetDataReducerState } from './factory/login/passwordResetReducer';

export interface RootState {
  sessionReducer: SessionReducerState;
  sideNavReducer: SideNavReducerState;
  snackbarReducer: SnackbarReducerState;
  blockUIReducer: BlockUIReducerState;
  versionCheckerReducer: VersionCheckerReducerState;
  navigationReducer: NavigationReducerState;
  passwordResetReducer: PasswordResetDataReducerState;
  form: FormStateMap;
}

export const STATE_RESET = 'STATE_RESET';

export interface BasicAction extends Action {
  type: string;
}

const appReducer = combineReducers({
  blockUIReducer,
  sessionReducer,
  sideNavReducer,
  versionCheckerReducer,
  navigationReducer,
  snackbarReducer,
  form: formReducer,
  passwordResetReducer,
});

const rootReducer: Reducer<RootState, BasicAction> = (state, action) => {
  let newState = state;

  if (action.type === STATE_RESET) {
    newState = undefined;
  }

  if (action.type === 'NAVIGATION_CHANGE') {
    newState = {
      ...state,
      navigationReducer: { notFound: false } as NavigationReducerState,
    };
  }

  return appReducer(newState, action);
};

export const resetState = (): BasicAction => ({
  type: STATE_RESET,
});

export const navigationChange = (): BasicAction => ({
  type: 'NAVIGATION_CHANGE',
});

export default rootReducer;
